<template>
  <level-formula-form
    :formula="formula"
    :is-loading="isLoading"
    :entities-by-id="entitiesById"
    @save="onSave"
    @close="$emit('close')"
  />
</template>

<script>
import { API } from '@/utils/api';
import LevelFormulaForm from '../components/LevelFormulaForm.vue';
const UPSERT_FORMULAE = '/$v/level_formulae/upsert.json';

export default {
  components: {
    LevelFormulaForm
  },
  props: {
    formula: {
      type: Object,
      default: () => ({})
    },
    entitiesById: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isLoading: false
    }
  },

  methods: {
    onSave(formula) {
      this.isLoading = true;

      return API.call(UPSERT_FORMULAE, { formula }).finally(() => {
        this.isLoading = false;
        this.$emit('reload');
      });
    }
  }
}
</script>
